// extracted by mini-css-extract-plugin
export default {"mapboxContainer":"BoardSection_mapboxContainer__53KM6","leafletBackground":"BoardSection_leafletBackground__at--j"};